(function($) {
	'use strict';
	$.fn.Slide__ProductPopup = function() {
		this.each(function() {

			/*
			 * Action: Add slide to collection
			 */
			var $self = $(this),
				data = $self.data('productdata'),
				$popup = $self.children('.popup'),
				o_ratio = data.image_w / data.image_h,
				$parent = $self.parent(),
				hide_timeout = 0,
				resize_timeout = 0,

				// The actual func
				touch_override = false,
				position_it = function() {

					// Close any existing popups
					$('.popup.on').removeClass('on');

					var parent_w = $parent.width(),
						parent_h = $parent.height(),
						p_ratio = parent_w / parent_h,
						image = {},
						p_of_o = 0; // <= percentage of original

					/*
					 * Calculate actual image width / height
					 */
					// Is portrait or landscape per the original ratio
					if( o_ratio > p_ratio ) {

						// height determines image width
						image.height = $parent.height();
						image.width = Math.round( data.image_w * ( image.height / data.image_h ) );

						// Offsets
						image.offset_x = ( image.width - parent_w ) / 2; // <= remainder / 2
						image.offset_y = 0;

					} else {

						// width determines image height
						image.width = parent_w;
						image.height = Math.round( data.image_h * ( image.width / data.image_w ) );

						// Offsets
						image.offset_x = 0;
						image.offset_y = ( image.height - parent_h ) / 2; // <= remainder / 2

					}

					// Get the percentage of original so we can calculate our new coords
					p_of_o = image.width / data.image_w;


					// Calculations
					var point_css = {
						'left': ( data.coords[0] * p_of_o ) - image.offset_x,
						'top': ( data.coords[1] * p_of_o ) - image.offset_y,
					};

					// Update coord positioning
					$self.css( point_css );

				};


			/*
			 * Popups: Desktop
			 */
 			$self.off( $.Globals.clickEvent )
				.on( $.Globals.clickEvent, function() {
					console.log('click');
					clearTimeout( hide_timeout );
				})
				.on('mouseenter', function() {
					console.log('mouseenter');
					clearTimeout( hide_timeout );

					// Turn it on
					$('.popup.on').removeClass('on');
					$popup.addClass('on');
				})
				.on('mouseleave', function() {
					console.log('mouseleave');

					let popup_close = touch_override ? 5000 : 1000; // <= edge touch doesn't close for 5 seconds
					hide_timeout = setTimeout( function() {
						$popup.removeClass('on');
					}, popup_close );

					touch_override = false;
				});



			// Disable traditional clicks
			// V1
			// $self.off( $.Globals.clickEvent ).on( $.Globals.clickEvent, function(e) {
			// 	e.preventDefault();
			// 	e.stopPropagation();
			// 	clearTimeout( hover_timeout );
			// });
			//
			// // Handle hover
			// $self.off( 'mouseover' ).on( 'mouseover', function() {
			// 	touch_override = false;
			// 	open_it('default');
			//
			// 	hover_timeout = setTimeout( () => {
			// 		close_it();
			// 	}, 2000 );
			// }).off('mouseleave').on('mouseleave', function() {
			// 	clearTimeout( hover_timeout );
			//
			// 	if( ! touch_override ) {
			// 		hover_timeout = setTimeout( () => {
			// 			close_it();
			// 		}, 2000 );
			// 	}
			// });


			// Edge touch events
			if( detectPointerEvents.hasApi && detectPointerEvents.maxTouchPoints > 0 ) { //<= if pointerevents is true (IE&chrome: https://caniuse.com/#search=pointer%20events )

				// NOTE: events for edge are "mouseenter", "touch", "click", "mouseleave" on all touches
				$self.on('pointerdown', function(e) {
					e.preventDefault();

					if( e.pointerType !== 'mouse' ) {
						touch_override = true;

						// Close if open (edge touch doesn't close popups)
						// if( $popup.hasClass('on') ) {
						// 	$popup.removeClass('on');
						// }

					}

				});

				// Listen for global closes
				$.Globals.listenForGlobalClosePopup();

			}





			$.Window.on('resize.product-popups', function() {

				clearTimeout( resize_timeout );

				// Reset Timeout
				resize_timeout = setTimeout( position_it, 300 );

			}).on('load.product-popups', function() {

				$.Window.trigger('resize.product-popups');

			});




		});
		return this;
	};
}(jQuery));
